app.component("patientNhi", {
	templateUrl: "app/src/js/components/patientHeader/patientNhi/patientNhi.html",
	controller: "patientNhiController",
	bindings: {
		hide: "&",
		eyeTitle: "@",
		hideSecondaryNhiComponent: "&",
	},
});

app.controller("patientNhiController", [
	"$scope",
	"PreOp",
	"NHI",
	"CurrentPatient",
	"PatientAPI",
	"$timeout",
	"NHISearchPatientsAPI",
	"Session",
	"$element",
	"NHI_VERSION_V2",
	function ($scope, PreOp, NHI, CurrentPatient, PatientAPI, $timeout, NHISearchPatientsAPI, Session, $element, NHI_VERSION_V2) {
		this.$onInit = function () {
			$scope.preop = PreOp;
			$scope.NHI_VERSION_V2 = NHI_VERSION_V2;
			$scope.PA = PatientAPI;
			this.PA = PatientAPI;
			$scope.CP = CurrentPatient;
			$scope.NHIAPI = NHISearchPatientsAPI;
			$scope.fhirNhiFeature = Session.practice.practiceFeatures.fhirNhiFeature;
			$scope.formData = {
				nhi: "",
			};
		};
		$scope.result = []
		$scope.isNHIFeatureEnabled = false;
		
		if (
			Session.practice.practiceFeatures &&
			(Session.practice.practiceFeatures.nhiFeature === true || Session.practice.practiceFeatures.fhirNhiFeature === true)
		) {
			$scope.isNHIFeatureEnabled = true;
		}

		// focus on input when component opens. Scoped to this component's own element because pre-op can
		// render a second patient-nhi instance, and both templates use the same #NHI id.
		const focusTimeout = $timeout(function () {
			const nhiInput = $element[0].querySelector("#NHI");
			if (nhiInput) {
				nhiInput.focus();
			}
			// $scope.fetchNHI('');
		}, 200);

		// the popover can be dismissed before the timeout fires, which destroys the component and its input
		$scope.$on("$destroy", function () {
			$timeout.cancel(focusTimeout);
		});

		$scope.fetchNHI = function(value, theForm) {
			if (value === "") {
				$scope.badNHI = false;
				theForm.NHI.$setValidity("badNHI", true);
				return [];
			}
			if (NHI.validate(value) === true) {
				$scope.badNHI = false;
				theForm.NHI.$setValidity("badNHI", true);
				$scope.loadingNHI = true;
				return new Promise((resolve, reject) => {
					searchNHIPatients(value,resolve,reject)
				  })
			} else {
				$scope.badNHI = true;
				theForm.NHI.$setValidity("badNHI", false);
				return [];
			}
		  };
		
		function searchAllNHIPatients(nhi) {
			return $scope.NHI_VERSION_V2 ? $scope.NHIAPI.searchAllNHIPatientsV2(nhi) : $scope.NHIAPI.searchAllNHIPatients(nhi);
		}

		function getNHICode(array) {
			if(!array || array.length === 0){
				return ''
			}
			const officialObj = array.find(t=>t.type === 'OFFICIAL');
			return (officialObj && officialObj.nhi) ? officialObj.nhi : array[0].nhi;
		}


		function searchNHIPatients(nhi, resolve, reject) {
			$scope.result = [];
			searchAllNHIPatients(nhi)
				.then(
					function (resp) {
						if (resp.data) {
							if($scope.NHI_VERSION_V2){
								//Map the NHI Patient, and add helper variables to the object
								const records = Array.isArray(resp.data) ? resp.data : [resp.data];
								$scope.result = records.map(t=>(
									{
										...t,
										...$scope.NHIAPI.getPreferredName(t.names),
										codedEthnicities:  angular.copy(t.ethnicities),
										nhi: getNHICode(t.nhi)
									}
								))
							}else{
								$scope.result=[resp.data]
							}

						}

						// A 204 (no record for this NHI) leaves the result empty, so the typeahead
						// shows its "No Results Found" state instead of never resolving.
						resolve($scope.result)
					},
					function (err) {
						// Resolved empty, not rejected: a rejection is unhandled inside the typeahead, and
						// "No Results Found" is the right thing to show while typing.
						console.error("NHI search failed:", err && err.status)
						resolve([])
					}
				).then(function () {
					$scope.loadingNHI = false;
				})
		}


		function composeDOB(dateOfBirth) {
			let DD,MM,YYYY;
			if($scope.fhirNhiFeature){
				DD = parseInt(dateOfBirth[0]);
				MM = parseInt(dateOfBirth[1]);
				YYYY = parseInt(dateOfBirth[2]);
			}else{
				DD = parseInt(dateOfBirth[2]);
				MM = parseInt(dateOfBirth[1]);
				YYYY = parseInt(dateOfBirth[0]);
			}
			// Zero-padded: "1980-3-5" is not an ISO date.
			const pad = (n) => (n < 10 ? "0" : "") + n;
			return `${YYYY}-${pad(MM)}-${pad(DD)}`;
		}

		function getNZCitizenState(nzCitizen) {
			if(nzCitizen === 'YES'){
			   return true;
			}else if(nzCitizen === 'NO'){
			   return false;
			}
			return null;
		 }

		function presetPatient(patient) {
			const DD = patient.dateOfBirth.substr(8, 2);
			const MM = patient.dateOfBirth.substr(5, 2);
			const YYYY = patient.dateOfBirth.substr(0, 4);
			$scope.CP.patient.lastName = patient.names[0].lastName;
			$scope.CP.patient.dateOfBirth = YYYY + "-" + MM + "-" + DD;
			$scope.CP.patient.firstName = patient.names[0].firstName;
			$scope.CP.patient.gender = $scope.NHIAPI.transformGenderProp(patient.gender);
			$scope.CP.patient.isResident = patient.isResident ? $scope.CP.patient.isResident : false;
			if (patient.contacts && patient.contacts.length > 0) {
				if (!patient.contacts[0].confidentialInformation) {
					$scope.CP.patient.phoneNumber = patient.contacts[0].phoneNumber
				}
			}
			$scope.CP.isPresetNewPatient = true;
		}

		function presetPatientV2(patient) {
			const dateOfBirth = patient.dob.split('-');
			const DD = parseInt(dateOfBirth[0]);
			const MM = parseInt(dateOfBirth[1]);
			const YYYY = parseInt(dateOfBirth[2]);
			
			$scope.CP.patient.dateOfBirth = composeDOB(dateOfBirth);
			$scope.CP.patient.lastName = patient.familyNameCol;
			$scope.CP.patient.firstName = patient.firstNameCol;
			$scope.CP.patient.nhi = patient.nhi;
			$scope.CP.patient.gender = $scope.NHIAPI.transformGenderProp(patient.gender);
			$scope.CP.patient.isResident = getNZCitizenState(patient.nzCitizen);
			$scope.CP.isPresetNewPatient = true;
		}


		$scope.saveSimpleNHI = function (nhi) {
			$scope.CP.patient.nhi = nhi;
			if(!$scope.CP.patient.id) {
				$scope.$ctrl.hide();
				return;
			} 
			$scope.PA.isProcessing = true;
			$scope.PA.update($scope.CP.patient)
				.then(function (resp) {
					$scope.CP.setPatient(resp.data);
				})
				.then(function () {
					$scope.PA.isProcessing = false;
					$scope.$ctrl.hide();
					$scope.$ctrl.hideSecondaryNhiComponent();
				})
				.catch(function (err) {
					$scope.PA.isProcessing = false;
					console.error("Failed to save NHI:", err && err.status);
				});
		};


		$scope.saveNHI = function (nhi) {
			if(!$scope.isNHIFeatureEnabled){
				$scope.saveSimpleNHI($scope.formData.nhi);
				return;
			}
			// The record the user picked - the search can return more than one.
			const selected = $scope.result.find(r => r && r.nhi === nhi);
			if(selected){
				const backupPatient = angular.copy($scope.CP.patient);
				$scope.CP.patient.nhi = nhi;

				if($scope.NHI_VERSION_V2){
					presetPatientV2(selected)
				}else{
					presetPatient(selected);
				}
   
				if(!$scope.CP.patient.id) {
					$scope.$ctrl.hide();
					return;
				} 
		
				$scope.PA.isProcessing = true;
				$scope.PA.update($scope.CP.patient)
					.then(function (resp) {
						$scope.CP.setPatient(resp.data);
						$scope.PA.isProcessing = false;
						$scope.$ctrl.hide();
						$scope.$ctrl.hideSecondaryNhiComponent();
					}, function (err) {
						// Left open, so a failed save does not read as a saved one.
						$scope.CP.setPatient(backupPatient);
						$scope.PA.isProcessing = false;
						console.error("Failed to save NHI:", err && err.status);
					});
			}
		};
	},
]);
